export type ReadingStatusFormType = 'pending' | 'completed' | 'saved'

// Constantes reutilizables
export const ReadingStatusForm = {
  Pending: 'pending' as ReadingStatusFormType,
  Completed: 'completed' as ReadingStatusFormType,
  Saved: 'saved' as ReadingStatusFormType,
}
